import { LessonIndexPageLevel } from '../models/LessonIndexPageLevel';
import { LevelResponse, LevelsResponse } from '../models/LevelPageUnit';
import api from './index';

interface LevelsProgressResponse {
  data: LessonIndexPageLevel[];
}

const getLevelsWithProgress = async () => {
  const { data } = await api.get<LevelsProgressResponse>('/v4/api/level?include=units');
  return data;
};

const getLevelWithUnits = async (levelPosition: string | null) => {
  const { data } = await api.get<LevelResponse>(`/v4/api/level/${levelPosition}?include=units`);
  return data;
};

const getLevels = async () => {
  const { data } = await api.get<LevelsResponse>(`/v4/api/level`);
  return data;
};

export const LevelService = {
  getLevelsWithProgress,
  getLevelWithUnits,
  getLevels,
};
